const exclude = list => val => !list.includes(val);
const include = list => val => list.includes(val);

export class URLManager {
  static defaults = {
    reqParams: new window.URLSearchParams(),
    reqWhitelist: [],
    hashBlacklist: [],
  };

  static sortParams(value) {
    const params = new window.URLSearchParams(value);
    params.sort();
    return params;
  }

  /**
   * @param {(USVString[]|URLSearchParams|USVString)[]} params
   * @returns {URLSearchParams}
   */
  static getParams(value = window.location.search) {
    const searchParams = URLManager.sortParams(value);

    if (!searchParams.toString().length) {
      return URLManager.sortParams(window.location.hash.slice(3));
    }

    return searchParams;
  }

  /**
   * @param {(USVString[]|URLSearchParams|USVString)[]} params
   * @returns {URLSearchParams}
   */
  static mergeSearchParams(params = []) {
    const mergedParams = params.reduce((accu, curr) => {
      let item = curr;

      if (curr instanceof window.URLSearchParams) {
        item = curr.toString();
      }

      const current = URLManager.sortParams(item);

      current.forEach((val, key) => {
        if (accu.has(key) && !val) {
          return accu.delete(key);
        }

        if (accu.has(key)) {
          return accu.set(key, val);
        }

        if (!val) {
          return null;
        }

        return accu.append(key, val);
      });

      return accu;
    }, new window.URLSearchParams());

    mergedParams.sort();
    return mergedParams;
  }

  /**
   * @param {URLSearchParams[]} params
   * @param {Function} predicate
   */
  static filterSearchParams(params = [], predicate) {
    const clone = new window.URLSearchParams();

    params.forEach((value, key) => {
      if (predicate && !predicate(key, value)) {
        clone.append(key, value);
      }
    });

    clone.sort();
    return clone;
  }

  /**
   * @returns {Boolean}
   */
  static isHash() {
    return window.location.hash.length > 0;
  }

  /**
   * @param {Object} options
   */
  constructor(options) {
    this.options = {
      ...URLManager.defaults,
      ...options,
    };

    const {baseUrl = window.location} = this.options;
    this.baseUrl = baseUrl;
  }

  /**
   * @param {Array} params
   */
  createRequestUrl(params = []) {
    const mergedParams = URLManager.mergeSearchParams([
      this.options.reqParams,
      ...params,
    ]);

    const filteredParams = URLManager.filterSearchParams(
      mergedParams,
      exclude(this.options.reqWhitelist),
    );

    return `${this.baseUrl}?${filteredParams}`;
  }

  /**
   * @param {Array} params
   */
  createHashUrl(params = []) {
    const mergedParams = URLManager.mergeSearchParams([
      URLManager.getParams(),
      ...params,
    ]);

    const filteredParams = URLManager.filterSearchParams(
      mergedParams,
      include(this.options.hashBlacklist),
    );

    return `${this.baseUrl}/#/?${filteredParams}`;
  }
}
